import { useState } from 'react';
import { Check, Copy } from 'lucide-react';

type Props = {
  link: string;
  /** Il suggerimento al passaggio del mouse: quale link si copia. */
  titolo: string;
};

/** Copia un link da mandare a chi non ha ricevuto o ha perso l'email (WhatsApp, telefono). */
export function CopiaLink({ link, titolo }: Props) {
  const [copiato, setCopiato] = useState(false);
  const copia = async () => {
    await navigator.clipboard.writeText(link);
    setCopiato(true);
    setTimeout(() => setCopiato(false), 2000);
  };
  return (
    <button
      type="button"
      onClick={() => void copia()}
      title={titolo}
      className="inline-flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 shadow-sm transition-colors hover:border-gray-300 hover:bg-gray-50"
    >
      {copiato ? <Check className="h-3.5 w-3.5 text-green-600" /> : <Copy className="h-3.5 w-3.5" />}
      {copiato ? 'Copiato' : 'Copia link'}
    </button>
  );
}
